import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
export default function riderAcceptedJob(job_id, component) {
  console.log("componentcheck", component);
  const Authorization = "bearer " + localStorage.getItem("token");
  fetch(`${API_URL}rest/V1/rider/updateJobStatus`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept, Authorization },
    body: JSON.stringify({ jobId: job_id, status: "assigned" }),
  })
    .then(function (response) {
      if (!response.ok) {
        notify.show("Network Failure", "error");
      }
      return response.json();
    })
    .then(function (data) {
      console.log("riderAcceptedJob", data);

      if (data[0].status == "success") {
        window.location.reload();
        return data.json();
      }

      //   localStorage.setItem("riderUpdstatus", data[0].data.status);
      //   component.props.updateStatusAction(data);
      //   if (data[0] && data[0].data === "success") {
      //     component.props.actionProcessingJobs(data[0].data);
      //   } else {
      //     component.props.actionProcessingJobs("failure");
      //   }
    });
}



// WEBPACK FOOTER //
// ./src/utility/api/riderAcceptedJob.js